export enum TranscriptStatus {
  Pending = 'pending',
  Recording = 'recording',
  Paused = 'paused',
  Completed = 'completed',
}
